import isEmptyField from './isEmptyField';
import filterPlural from '../filterPlural';
/**
 * Check for the minimum value
 * @param {string} value
 * @param {number} min
 * @param {string} error
 * @returns {string|null}
 */
const minLength = (
  value,
  min,
  error = `Мин. ${min} ${filterPlural(['символ', 'символа', 'символов'], min)}`
) => (!isEmptyField(value) && value.length < min ? error : null);

export default minLength;
